import { userSlice } from './UserSlice';

export const sliceApi = {
  users: userSlice
};
